import { Icon } from '@chakra-ui/react';
import React from 'react';

export const CloseIcon = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            id="Combined_Shape"
            d="m8.369 9.776-.076-.068L5 6.414 1.707 9.707A1 1 0 0 1 .225 8.369l.068-.076L3.586 5 .293 1.707A1 1 0 0 1 1.632.225l.076.068L5 3.586 8.293.293a1 1 0 0 1 1.483 1.339l-.068.076L6.414 5l3.293 3.293a1 1 0 0 1-1.338 1.483z"
            className="cls-1"
            data-name="Combined Shape"
          />
        </clipPath>
      </defs>
      <g id="feather_cross" data-name="feather / cross" transform="translate(2.378 .378)" fill="currentColor">
        <g id="Group_20" data-name="Group 20" transform="translate(-2.378 -.378)">
          <path
            id="Combined_Shape-2"
            d="m8.369 9.776-.076-.068L5 6.414 1.707 9.707A1 1 0 0 1 .225 8.369l.068-.076L3.586 5 .293 1.707A1 1 0 0 1 1.632.225l.076.068L5 3.586 8.293.293a1 1 0 0 1 1.483 1.339l-.068.076L6.414 5l3.293 3.293a1 1 0 0 1-1.338 1.483z"
            className="cls-1"
            data-name="Combined Shape"
          />
          <g id="Mask_Group_20" clipPath="url(#clip-path)" data-name="Mask Group 20">
            <g id="COLOR_black" data-name="COLOR/ black" transform="translate(-3 -3)">
              <path id="Rectangle" d="M0 0h16v16H0z" className="cls-1" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  );
};
